define('AwaLabs.ProductStock404', [
    'ProductDetails.Base.View',
    'AjaxRequestsKiller',
    'Backbone',
    'Utils',
    'underscore',
    'jQuery'
], function AwaLabsProductStock404(
    ProductDetailsBaseView,
    AjaxRequestsKiller,
    Backbone,
    Utils,
    _,
    jQuery
) {
    'use strict';

    _.extend(ProductDetailsBaseView.prototype, {
        productDetails: function productDetails(apiQuery, options) {
            var application = this.application;
            var product = this.model;
            var promise = jQuery.Deferred();
            var item = product.get('item');
            var self = this;

            item.fetch({
                data: apiQuery,
                killerId: AjaxRequestsKiller.getKillerId(),
                pageGeneratorPreload: true
            }).then(function then(data, _result, jqXhr) {
                if (!item.isNew()) {
                    product.setOptionsFromURL(options);
                    product.set('source', options && options.source);
                    product.set('internalid', options && options.internalid);
                    if (apiQuery.id && item.get('urlcomponent') && SC.ENVIRONMENT.jsEnvironment === 'server') {
                        nsglobal.statusCode = 301;
                        nsglobal.location = Utils.addSlashToURL(product.generateUrl());
                    }

                    if (data.corrections && data.corrections.length > 0) {
                        if (item.get('urlcomponent') && SC.ENVIRONMENT.jsEnvironment === 'server') {
                            nsglobal.statusCode = 301;
                            nsglobal.location = Utils.addSlashToURL(data.corrections[0].url) + product.getQuery();
                        } else {
                            Backbone.history.navigate(
                                '#' + data.corrections[0].url + product.getQuery(),
                                { trigger: true }
                            );
                            promise.reject();
                        }
                    }

                    self.bindModel();
                    promise.resolve();
                } else if (jqXhr.status >= 500) {
                    application.getLayout().internalError();
                    promise.reject();
                } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
                    application.getLayout().notFound();
                    promise.reject();
                }
            },
            function (jqXhr) {
                jqXhr.preventDefault = true;
                if (jqXhr.status >= 500) {
                    application.getLayout().internalError();
                    promise.reject();
                } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
                    // We just show the 404 page
                    application.getLayout().notFound();
                    promise.reject();
                }
            });

            return promise;
        }
    });
});
